import { RatePlan } from '~/hooks/apis/reservation/usePropertyRatePlans';

export interface RateStrategyPanelProps {
  ratePlans: Array<RatePlan>;
  ratePlansLoading: boolean;
  ratePlansError?: unknown;
  lpcPromotionalDiscounts: Array<App.RatePlanPromotion>;
  promotionsLoading: boolean;
  promotionsError?: unknown;
}

export const defaultRateStrategyPanelProps: RateStrategyPanelProps = {
  ratePlans: [],
  ratePlansLoading: false,
  lpcPromotionalDiscounts: [],
  promotionsLoading: false,
};
